/* eslint-disable */

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/js/collapse.js';
import 'bootstrap/js/carousel.js';
import './LandingPagecss.css';
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css

import React, { Component, Suspense, lazy } from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import $ from 'jquery';
import CustomChatbot from "./CustomChatbot";
import { LoadingPage } from './LoadingPage';
import ReactDOM from 'react-dom';
import VerificationPage from './VerificationPage';
import { confirmAlert } from 'react-confirm-alert'; // Import
import dashboard from './image/dashboard.png';
import download_img2 from './image/icon/download_img2.png';
import feature_img_ss1 from './image/feature/feature_img_ss1.png';
import feature_img_ss2 from './image/feature/feature_img_ss2.png';
import feature_img_ss3 from './image/feature/feature_img_ss3.png';
import icon from './image/icon/icon_check.png';
import icon_aws from './image/icon/aws_icon.ico';
import icon_clock from './image/icon/icon_clock.png';
import icon_drive from './image/icon/drive_icon.png';
import icon_dynamic from './image/icon/icon_dynamic.png';
import icon_leave from './image/icon/icon_leave.png';
import icon_location from './image/icon/icon_location.png';
import icon_offline from './image/icon/icon_offline.png';
import icon_privacy from './image/icon/icon_privacy.png';
import main_img from './image/hero/main_img.png';
import monitor1 from './image/monitor1.jpg';
/* sec4_1 */
import sec_1 from './image/icon/sec_1.png';
import sec_2 from './image/icon/sec_2.png';
import sec_3 from './image/icon/sec_3.png';
import sec_4 from './image/icon/sec_4.png';
import sec_5 from './image/icon/sec_5.png';
import sec_8 from './image/icon/sec_8.png';
import sec_9 from './image/icon/sec_9.png';
//import "bootstrap/js/collapse.js"; 
import t2 from './image/tictokn.png';

const SignIn = lazy(() => import('./SignIn'));
const SignUp = lazy(() => import('./SignUp'));
const Downloadpage = lazy(() => import('./Downloadpage'));
const ForgotPassword = lazy(() => import('./ForgotPassword'));
const OnPremiseSignup = lazy(() => import('./OnPremise_signup'));
const ResetPasswordLogin = lazy(() => import('./ResetPasswordLogin'));
class LandingPage extends Component {
  constructor() {
    super();
    this.state = {
      emailId: "",
      name: "",
      comments: "",
      password: "",
      date: "",
      formErrors: { emailId: "", password: "" },
      emailIdValid: false,
      passwordValid: false
    };
  }

  handleUserInput = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };


  LoginBtn() {
    ReactDOM.render(
      <Router>
        <Suspense fallback={<LoadingPage />}>
          <div >
            <Route  path="/" component={SignIn} />
          </div>
        </Suspense>
      </Router>, document.getElementById('root'));

  }
  SignUpBtn() {
    var newurl = '/Signup';
    window.history.replaceState({}, document.title, newurl);
    ReactDOM.render(
      <Router>
        <Suspense fallback={<LoadingPage />}>
          <div >
            <Route path="/" component={SignUp} />
          </div>
        </Suspense>
      </Router>, document.getElementById('root'));

  }
  DownloadpageFunc() {
    var newurl = '/DownloadApps';
    window.history.replaceState({}, document.title, newurl);
    ReactDOM.render(
      <Router>
        <Suspense fallback={<LoadingPage />}>
          <div >
            <Route path="/" component={Downloadpage} />
            <Route exact path="/DownloadApps" component={Downloadpage} />
          </div>
        </Suspense>
      </Router>, document.getElementById('root'));

  }
  OnPremiseSignupFunc() {
    ReactDOM.render(
      <Router>
        <Suspense fallback={<LoadingPage />}>
          <div >
            <Route path="/" component={OnPremiseSignup} />
          </div>
        </Suspense>
      </Router>, document.getElementById('root'));
  }
  componentDidMount() {

    // The function toggles more (hidden) text when the user clicks on "Read more".
    //The IF ELSE statement ensures that the text 'read more' and 'read less' changes
    //interchangeably when clicked on.
    if (window.location.pathname != "/") {
      if (window.location.pathname === "/RemoteAttendanceDateWise") {
        var newurl = '/';
        window.history.replaceState({}, document.title, newurl);
      }
      ReactDOM.render(
        <Router>
          <Suspense fallback={<LoadingPage />}>
            <div >
              <Route exact path="/" component={LandingPage} />
              <Route exact path="/ForgotPassword" component={ForgotPassword} />
              <Route exact path="/VerificationPage*" component={VerificationPage} />
              <Route exact path="/VerifyCode*" component={VerificationPage} />
              <Route exact path="/VerifyPassword*" component={ResetPasswordLogin} />
              <Route exact path="/DownloadApps*" component={Downloadpage} />
              <Route exact path="/RemoteAttendanceDateWise*" component={LandingPage} />
            </div>
          </Suspense>
        </Router>, document.getElementById('root'));
    }
    $(".moreless-button").click(function () {
      $(".moretext").slideToggle();
      console.log("$('.moreless-button').text()", $(".moreless-button").text());
      if ($(".moreless-button").text() == "+++") {
        $(".moreless-button").text("-");
      } else {
        $(".moreless-button").text("+");
      }
    });
    /* 
        $(document).ready(function(){
    $(".autoclose_menu").on("click", function () {
      alert("ji");
      $("#mynavbar").addclass("collapse");
    });
    
        });
     */

  }

  readMore() {
    var dots = document.getElementsByClassName("dots");
    var moreText = document.getElementsByClassName("more");
    var btnText = document.getElementById("myBtn");

    if (dots[0].style.display == "none") {
      dots[0].style.display = "inline";
      btnText.innerHTML = "+";
      moreText[0].style.display = "none";
    } else {
      dots[0].style.display = "none";
      btnText.innerHTML = "Read less";
      moreText[0].style.display = "inline";
    }
  }
  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value },
    );
  }

  Submit() {
    var self = this;
    if (this.state.name.trim().length > 0 && this.state.emailId.trim().length > 0 && this.state.comments.trim().length > 0) {
      $.ajax({
        type: "POST",
        data: JSON.stringify({
          emailId: this.state.emailId,
          userName: this.state.name,
          comments: this.state.comments
        }),
        //url:"http://localhost:8080/EmployeeAttendenceAPI/ContactPageMail/ContactPage",
        url: serverUrl+"/EmployeeAttendenceAPI/ContactPageMail/ContactPage",
        contentType: "application/json",
        dataType: "json",
        async: false,
        success: function (data, textStatus, jqXHR) {
          confirmAlert({
            title: "Success", // Title dialog
            message: "Message Sent Successfully. ", // Message dialog
            confirmLabel: "Ok" // Text button confirm
          });
          self.state.emailId = "";
          self.state.name = "";
          self.state.comments = "";
        },

        error: function (data) {
          confirmAlert({
            title: "Error", // Title dialog
            message: "Try Again Later", // Message dialog
            confirmLabel: "Ok" // Text button confirm
          });
        }
      });
    } else {
      confirmAlert({
        title: "Error", // Title dialog
        message: "Enter all the Fields", // Message dialog
        confirmLabel: "Ok" // Text button confirm
      });
    }
  }

  render() {

    return (

      <div id="myPage" class="container-fluid landing_page" data-spy="scroll" data-target=".navbar" data-offset="60">
        <nav
          class="navbar navbarcss navbar-default navbar-fixed-top"
          style={{ padding: "0px" }}
        >
          <div
            class="container"
            style={{
              backgroundColor: "white",
              width: "-webkit-fill-available",
              borderRadius: "5px",


            }}
          >
            <div class="navbar-header">
              <button class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                <span class="icon-bar" />
                <span class="icon-bar" />
                <span class="icon-bar" />
              </button>

              <a class="navbar-brand navbar-brand-css" href="#myPage">
                <img
                  style={{ width: "70px", height: "auto", marginTop: "-35px", padding: '10px', marginRight: '-25px' }}
                  src={t2}
                  className=" logo_Tictoks"
                  alt="Paris"
                  width="400"
                  height="300"
                />
              </a>
              <span
                class="navbar-text "
                id="menuheaderName"
                style={{ marginTop: '10px', textTransform: 'capitalize' }}

              >
                Tictoks
              </span>
            </div>
            <div
              class="collapse navbar-collapse"
              id="myNavbar"
              style={{ marginTop: "0px" }}
            >
              <ul
                class="nav navbar-nav navbar-right navbarMenu"
                style={{ marginRight: "0px", fontSize: "12px" }}
              >


                <li>
                  <a href="#solution">Solution</a>
                </li>
                <li>
                  <a href="#benefits">Benefits</a>
                </li>
                {/* <li>
                  <a href="#pricing">PRICING</a>
                </li> */}
                <li>
                  <a href="#features">Features</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
                <li class="">
                  <a onClick={() => this.LoginBtn()} style={{ color: '#6f64ff' }}>Login</a>
                </li>
                <button type="button" class="btn_class_download" onClick={() => this.DownloadpageFunc()}>Download App</button>
                {/*   <button type="button" class="btn_class_download" onClick={() => this.OnPremiseSignupFunc()}>On Premise Signup</button>
               */}
              </ul>

            </div>
          </div>
        </nav>

        <div class="container-fluid" >
          <div id="myCarousel" class="carousel slide lp_slider_maindiv" data-ride="carousel">
            <div class="row" id="home">
              <div class="col-md-6  header_sec" style={{}}>
                <div class="header_text ">
                  <div class="text-center">
                    <h2 class="text_form"> The All-in-One Remote <br></br> <span>Business Productivity</span> <br></br> Toolkit </h2>
                    {/* <h2 class="text_css"> to enhance your employee productivity</h2> */}

                    <h5 class="head_para">Employee Monitoring Software that enhances your employee productivity<span> by 30%</span></h5>
                  </div>

                  <div class="header_button">
                    <button type="button" class="btn_class" onClick={() => this.SignUpBtn()}>Sign up</button>
                    <button type="button" class="btn_outlinecls btn-outline-primary" onClick={() => window.open('https://throughapps.com/book-a-demo/', '_blank')}>Book A Demo</button>
                  </div>
                  <div>
                    <p class="head_para" style={{ fontSize: '18px', color: '#6f64ff' }}>Try free for 14 days. No Credit Card required</p>
                  </div>
                </div>
                {/* <svg class="dots-left" width="235" height="70.2" enable-background="new 0 0 235 70.2" viewBox="0 0 235 70.2" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><linearGradient id="b" x1="965.37" x2="1200.4" y1="233.06" y2="233.06" gradientTransform="matrix(1 0 0 -1 -965.37 268.16)" gradientUnits="userSpaceOnUse"><stop stop-color="#24CCFD" offset="0"></stop><stop stop-color="#5951FF" offset="1"></stop></linearGradient><path style="fill:url(#b);" d="m6.6 66.9c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3zm32.6 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.9 0 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c2 0 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3zm-228.4-21.3c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.4 3.3 3.4 3.3-1.5 3.3-3.4zm32.6 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.4 3.4 3.3 3.4 3.3-1.5 3.3-3.4zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.4 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.9 0.1 3.3-1.4 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8 0.1 3.3-1.4 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8 0.1 3.3-1.4 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c2 0.1 3.3-1.4 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8 0.1 3.3-1.4 3.3-3.3zm-228.4-21c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.4-3.3 3.3c0 1.8 1.5 3.3 3.3 3.3 1.8-0.2 3.3-1.5 3.3-3.3zm32.6 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.2 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.7-0.2 3.3-1.5 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.9-0.2 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.2 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.2 3.3-1.5 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c2-0.2 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.2 3.3-1.5 3.3-3.3zm-228.4-21.3c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.1 3.3-1.5 3.3-3.3zm32.6 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.1 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.7-0.1 3.3-1.5 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.9-0.1 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.1 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.1 3.3-1.5 3.3-3.3zm32.5 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c2-0.1 3.3-1.5 3.3-3.3zm32.7 0c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3c1.8-0.1 3.3-1.5 3.3-3.3z"></path></svg> */}
              </div>

              <div class="col-md-6">

                <div class="carousel-inner">
                  <div class="item active">
                    <img src={main_img} alt="Los Angeles" style={{ width: "100%" }} />
                  </div>

                  {/* <div class="item">
                                        <img src={main_img} alt="Chicago" style={{ width: "100%;" }} />
                                  </div>

                                  <div class="item">
                                        <img src={img2} alt="New York" style={{ width: "100%;" }} />
                                  </div>

                                  <div class="item">
                                        <img src={img1} alt="New York" style={{ width: "100%;" }} />
                                  </div> */}
                </div>
              </div>
            </div>

          </div>
        </div>


        <div class="container-fluid">
          <div class="" style={{ marginBottom: '70px', marginTop: '60px' }}>
            <h3 class="box-container_text">Trusted By</h3>
            <div role="list" class="customer-logo__home w-dyn-items text-center">
              <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
                <img src={sec_1} loading="lazy" alt="Realm" class="logo-home" />
              </div>
              <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
                <img src={sec_2} loading="lazy" alt="Adobe" class="logo-home" />
              </div>
              <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
                <img src={sec_3} loading="lazy" alt="Unity" class="logo-home" />
              </div>
              <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
                <img src={sec_4} loading="lazy" alt="Fluentd" class="logo-home" />
              </div>
              <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
                <img src={sec_5} loading="lazy" alt="Flatfile" class="logo-home" />
              </div>
              {/* <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
              <img src={sec_6} loading="lazy" alt="Flatfile" class="logo-home"/>
              </div> */}
              {/* <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
              <img src={sec_7} loading="lazy" alt="Flatfile" class="logo-home"/>
              </div> */}
              <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
                <img src={sec_8} loading="lazy" alt="Flatfile" class="logo-home" />
              </div>
              <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
                <img src={sec_9} loading="lazy" alt="Flatfile" class="logo-home" style={{}} />
              </div>
              {/* <div id="w-node-_31c04aa6-7cb2-4700-17e1-388cdfe6ecb7-932a18f0" role="listitem" class="w-dyn-item">
              <img src={sec_10} loading="lazy" alt="Flatfile" class="logo-home"/>
              </div> */}

            </div>
          </div>
        </div>
        {/* ------secton2------ */}

        <div className="top-banner row m0 text-center fadeInOnLoad">
          <div class="home-under-hero-section" >
            {/* <img src={dashboard_background} class="bg_image_dashboard"style={{width:'100%'}}/> */}

            <div class="container-fluid" style={{ marginTop: "0px", paddingTop: "50px" }}>
              <div class="col-md-6">
                <div class="row apple-watch">
                  <img
                    src={dashboard}
                    style={{}}
                    alt=""
                    class="watch_img"
                  />

                </div>
              </div>
              <div class="col-md-6 dashboard_section_text" style={{ marginBottom: '80px', padding: '20px' }}>
                <h3 className="sectionHeader">Real-time Monitoring</h3>
                <h3 class="sectionHeaderText_sub">Touchless Facial Recognition</h3>
                <p class="section_para">
                  Welcome to the Next-Gen Technology of Touchless Face Attendance to capture and
                  recognize the face of an remote employee while maintaining utmost Security of your data.
                </p>

                <h3 class="sectionHeaderText_sub">Real-time Attendance Management</h3>
                <p class="section_para">
                  Tictoks software monitors remote employee attendance effortlessly from check-in to check out.
                  Application provides two-factor authentication for employees to ensure utmost security.
                </p>
              </div>

              {/* 	<a href="https://vimeo.com/142705963" class="btn btn-primary btn-lg video">Play
                      <img src="images/play-btn-icon.png" alt="" /> Video</a> */}
              <br />
              {/* <a href="#product-choose" class="btn btn-warning btn-lg visible-sm-inline-block visible-xs-inline-block">pre-order now</a> */}

            </div>
          </div>
        </div>



        {/* ---section3--- */}
        <div class="container-fluid" id="benefits" style={{ marginTop: '100px' }}>
          <div class="row">
            <div class="col-md-7">
              <h3 class="box-container_text">Why use Employee Monitoring Software?</h3>
              <ul>
                <li class="list_text">
                  <p class="box-container-para"><img src={icon} style={{ width: '4%', marginRight: '10px' }} /> 30% improvement in remote employee's productivity</p>
                </li>
                <li class="list_text">
                  <p class="box-container-para"><img src={icon} style={{ width: '4%', marginRight: '10px' }} /> Get actual Logins & Logout for the day</p>
                </li>
                <li class="list_text">
                  <p class="box-container-para"><img src={icon} style={{ width: '4%', marginRight: '10px' }} /> Total time spent on work, meetings & break</p>
                </li>
                <li class="list_text">
                  <p class="box-container-para"><img src={icon} style={{ width: '4%', marginRight: '10px' }} /> Analyzing Improvement area to boost productivity</p>
                </li>
                <li class="list_text">
                  <p class="box-container-para"><img src={icon} style={{ width: '4%', marginRight: '10px' }} /> Identify actual time spent on project and task</p>
                </li>
                <li class="list_text">
                  <p class="box-container-para"><img src={icon} style={{ width: '4%', marginRight: '10px' }} /> 100% transparency between remote teams & managers</p>
                </li>
                <li class="list_text">
                  <p class="box-container-para"><img src={icon} style={{ width: '4%', marginRight: '10px' }} /> Reduce business operation cost by 40%</p>
                </li>
              </ul>
            </div>
            <div class="col-md-5">
              <img src={monitor1} style={{ width: '100%' }} />
            </div>
          </div>
        </div>
        {/* ---section3 ends--- */}
        {/* section4 */}
        <div class="container-fluid" id="features">
          <h2 class="sec4_header">Features of Employee Monitoring Software</h2>
          <div class="container-fluid">
            <div class="row feature_row">
              <h2 class="feature_header">Productive Monitoring</h2>
              <div class="col-md-6 feature_sec" style={{}}>

                <h3 class="sec_sub"><i class="fa fa-map-marker list_icon" aria-hidden="true"></i>Application Tracking</h3>
                <p class="feature_para">Tictoks monitors usage and time spent on each productive & non-productive applications.
                  Get insights into all application activities of the remote workers.</p>
                <h3 class="sec_sub"><i class="fa fa-history list_icon" aria-hidden="true"></i>Browser History Monitoring</h3>
                <p class="feature_para">Monitors which websites remote employees using individually and each time spent on websites.
                  This prevents the remote teams from using non-productive websites.</p>

              </div>
              <div class="col-md-6">
                <div class="">
                  <img src={feature_img_ss1} class="feature_img image_bg" />
                </div>

              </div>

            </div>
          </div>
        </div>
        {/* section 4 ends */}

        {/* section5 */}
        <div class="container">

          <div class="row feature_row">
            <h2 class="feature_header">Proof of work</h2>
            <div class="col-md-6">
              <div class="">
                <img src={feature_img_ss2} class="image_bg1 feature_img" />
              </div>
            </div>

            <div class="col-md-6 feature_sec" style={{}}>

              <h3 class="sec_sub"><i class="fa fa-keyboard-o list_icon" aria-hidden="true"></i> Keystroke Monitoring</h3>
              <p class="feature_para">Total keystrokes, Mouse clicks & Mouse scrolls are tracked using Tictoks. This helps the employer to restrict the remote employees from being
                idle and help them focus more on their assigned goals</p>

              <h3 class="sec_sub"><i class="fa fa-picture-o list_icon" aria-hidden="true"></i>Screenshot Monitoring</h3>
              <p class="feature_para">Automatic screenshots of employee monitors can be captured at configured time intervals.
                This Prevents the employee from indulging in unofficial activities.</p>

            </div>

          </div>
        </div>
        {/* section5 ends */}

        {/* section6 */}
        <div class="container-fluid">

          <div class="row feature_row">
            <h2 class="feature_header">Track your remote employee's work</h2>
            <div class="col-md-6 feature_sec" style={{}}>

              <h3 class="sec_sub"><i class="fa fa-tasks list_icon" aria-hidden="true"></i>Task Management</h3>
              <p class="feature_para">Track task from beginning to end, assigning subtasks to teammates, setting deadlines to make sure work gets done on time.</p>
              <h3 class="sec_sub"><i class="fa fa-clock-o list_icon" aria-hidden="true"></i>Active & Idle-time Monitoring</h3>
              <p class="feature_para">Tictoks monitors total working hours, idle time taken by remote workers. It helps employer to analyze productive hours of the entire organization with insightful charts.</p>

            </div>
            <div class="col-md-6">
              <div>
                <img src={feature_img_ss3} class=" feature_img image_bg3" />
              </div>
            </div>


          </div>
        </div>



        <div class="container" id="solution" data-aos="fade-up">
          <h2 class="sec4_header" style={{ marginBottom: '50px' }}>More than Time and Attendance Tictoks provides</h2>

          <div class="row" >
            <div class="col-md-4">
              <div class="card text-center">
                <img src={icon_dynamic} class="icon_css " />
                <h3 class="">Dynamic Shift</h3>
                <div>Tictoks helps to create N number of shifts and saves time spent on manual shift scheduling by more than 50%.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card text-center">
                <img src={icon_leave} class="icon_css " />
                <h3 class="">Leave Management</h3>
                <div>Tictoks provides a one-step process for raising and approving leave applications.
                  Permissions can be assigned to managers for the approval process.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card text-center">
                <div class="icon_box">
                  <img src={icon_location} class="icon_css " />

                </div>
                <h3 class="">Location Tracking</h3>
                <div>Employees locations can be tracked using Google maps. location of the last login can be tracked.</div>
              </div>
            </div>
          </div>
          <div class="row" style={{ marginTop: '20px' }}>
            <div class="col-md-4">
              <div class="card text-center">
                <img src={icon_privacy} class="icon_css " />
                <h3 class="">Privacy</h3>
                <div >Tictoks remote employee monitoring tool monitors activities only when employees are Checked In.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card text-center">
                <img src={icon_clock} class="icon_css " />
                <h3 class="">Manual Time</h3>
                <div >Employees' can manually mark their missed attendance.
                  It will be sent to the respective reporting managers for approval.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card text-center">
                <div class="icon_box">
                  <img src={icon_offline} class="icon_css " />

                </div>
                <h3 class="">Offline Mode</h3>
                <div >Employees' data can be tracked even during offline mode.
                  All data will be synchronized with your account once the device comes online.</div>
              </div>
            </div>
          </div>
        </div>
        <section id="background_image">
          <div class="container">
            <div class="grid">
              <h3 class="grid_text">How Tictoks stores your data securely?</h3>
              <div class="col-md-6 text-center" style={{ marginTop: '30px' }}>
                <img src={icon_aws} style={{ width: '33%' }} />
                <h3 class="grid_sub">AWS Cloud</h3>
                <p class="section_para1">Tictoks allows you to stores your employees data in your own AWS server or our team will guide you to create new AWS account,
                  which can be accessed only by the user.</p>
              </div>
              <div class="col-md-6 text-center">
                <img src={icon_drive} style={{ width: '40%' }} />
                <h3 class="grid_sub">Google Drive Integration</h3>
                <p class="section_para1">For small organization, Tictoks allows to store employees data in affordable Google drive account.
                  Data stored in the drive are accessible only by the user.</p>
              </div>

            </div>
          </div>
        </section>



        {/* ---clientsec--- */}
        {/* <hr style={{marginTop:'200px',borderTop:'5px solid #6f64ff'}}></hr> */}

        {/* ---clientsec end--- */}
        <div class="banner_img">
          <div class="">

            <div class="section_content">

              <h2 class="content_text">Tictoks - Employee Monitoring Software</h2>
              <p class="content_para">A progressive web software developed to provide complete employee monitoring solutions for customers.</p>
              <p class="content_para">Smart solution for the modern workplace.</p>
              <div class="text-center">
                <a href="https://throughapps.com/book-a-demo/">  <button type="button" class="btn_class" style={{ background: '#fff', color: '#6f64ff', marginTop: '20px' }}> Book A Demo </button></a>
              </div>
            </div>
          </div>

        </div>

        <div class="container-fluid" id="contact" style={{ padding: '30px', background: '', color: '#000' }}>


          <div class="contact" >
            <div class="col-md-4">
              <h2 class="map_header">Contact Us</h2>
              <p class="map_text"> Throughapps,</p>
              <p class="map_text"> Village High Road,</p>
              <p class="map_text">Shollinganallur, Chennai.</p>
              <p class="map_text">Ph:(+91)90031 14243</p>
              <p class="map_text" >sales@throughapps.com</p><br></br>

            </div>
            <div class="col-md-4">
              <h2 class="map_header">Our Products</h2>
              <p class="map_text">  Tictoks </p>
              <p class="map_text">  Remote Employee Monitoring</p>
              <p class="map_text">Dynamic Shift Management</p>
              <p class="map_text">Smart Biometric RFID Device</p>

            </div>
            <div class="col-md-4 text-center">
              <h2 class="map_header "> Get It On</h2>
              <div class="">
                <img onClick={() => this.DownloadpageFunc()} src={download_img2} style={{ width: '50%' }} />
              </div>
            </div>
          </div>
        </div>
        <CustomChatbot eventHandler={this.clickEventHandler} />
      </div>
    );
  }
}


export default LandingPage;

